'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
import * as $j_mealorama$002e$002dMeal$002dType from "./mealorama.-Meal-Type.js";
var $p;
/** @constructor */
function $c_Lmealorama_MealType$$anon$5() {
  this.uC = 0;
  this.rk = null;
  this.wA = null;
  $j_mealorama$002e$002dMeal$002dType.$ct_Lmealorama_MealType__I__T__T__(this, 4, "other", "Other");
}
export { $c_Lmealorama_MealType$$anon$5 as $c_Lmealorama_MealType$$anon$5 };
$p = $c_Lmealorama_MealType$$anon$5.prototype = new $j_mealorama$002e$002dMeal$002dType.$h_Lmealorama_MealType();
$p.constructor = $c_Lmealorama_MealType$$anon$5;
/** @constructor */
function $h_Lmealorama_MealType$$anon$5() {
}
export { $h_Lmealorama_MealType$$anon$5 as $h_Lmealorama_MealType$$anon$5 };
$h_Lmealorama_MealType$$anon$5.prototype = $p;
$p.q = (function() {
  return 0;
});
$p.g = (function(n) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sr_EnumValue__productElement__I__O(this, n);
});
$p.r = (function() {
  return "other";
});
$p.m = (function() {
  return "other";
});
$p.p = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_T__hashCode__I("other");
});
var $d_Lmealorama_MealType$$anon$5 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lmealorama_MealType$$anon$5, "mealorama.MealType$$anon$5", ({
  Gz: 1,
  cb: 1,
  b: 1,
  c: 1,
  a: 1,
  l: 1,
  n: 1,
  d: 1,
  e: 1,
  h: 1
}));
export { $d_Lmealorama_MealType$$anon$5 as $d_Lmealorama_MealType$$anon$5 };
//# sourceMappingURL=mealorama.-Meal-Type$$anon$5.js.map
